var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthNameLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "svg6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 20.1633,4.09295 15.0612,2.17072 C 14.1429,1.86721 13.2245,1.96838 12.5102,2.47423 12.2041,2.67657 12,2.87891 11.7959,3.08125 H 7.91837 c -1.53061,0 -2.85715,1.31521 -2.85715,2.83276 V 6.9257 c 0,0.40468 0.30613,0.80936 0.81633,0.80936 0.51021,0 0.81633,-0.40468 0.81633,-0.80936 V 5.91401 c 0,-0.70819 0.61224,-1.21404 1.22449,-1.21404 H 11.2857 V 19.3696 H 7.91837 c -0.71429,0 -1.22449,-0.607 -1.22449,-1.2141 v -1.0116 c 0,-0.4047 -0.30612,-0.8094 -0.81633,-0.8094 -0.5102,0 -0.81633,0.3035 -0.81633,0.7082 v 1.0117 c 0,1.5175 1.2245,2.8327 2.85715,2.8327 H 11.7959 C 12,21.0895 12.2041,21.393 12.4082,21.4942 12.9184,21.7977 13.4286,22 14.0408,22 c 0.3061,0 0.7143,-0.1012 1.0204,-0.2023 l 5.1021,-1.9223 C 21.2857,19.4708 22,18.4591 22,17.245 V 6.62219 C 22,5.50933 21.1837,4.39646 20.1633,4.09295 Z",
    fill: "#346CF0",
    id: "path2",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6.38776,13.5017 c -0.30613,0.3035 -0.30613,0.8094 0,1.1129 0.10204,0.1012 0.30612,0.2023 0.5102,0.2023 0.20408,0 0.40816,-0.1011 0.5102,-0.2023 l 2.04082,-2.0234 c 0.10204,-0.1012 0.10204,-0.2023 0.20408,-0.2023 0,-0.1012 0.10204,-0.2024 0.10204,-0.3035 0,-0.1012 0,-0.2024 -0.10204,-0.3035 0,-0.1012 -0.10204,-0.2024 -0.20408,-0.2024 L 7.40816,9.55612 c -0.30612,-0.30351 -0.81632,-0.30351 -1.12245,0 -0.30612,0.30351 -0.30612,0.80938 0,1.11288 L 7,11.3772 H 2.81633 C 2.40816,11.3772 2,11.6807 2,12.1865 c 0,0.5059 0.30612,0.8094 0.81633,0.8094 h 4.28571 z",
    fill: "#346CF0",
    id: "path4",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthNameLogo);
export default __webpack_public_path__ + "static/media/auth-name-logo.448f793c0b65b63df4dd34e82d183282.svg";
export { ForwardRef as ReactComponent };